import processPptx from './processPptx'

// shim worker
const worker = {
  postMessage: ({}: { type: string; data: any }) => {},
  terminate: () => {}
}

const parsePptxSlides = (pptxArrayBuffer: ArrayBuffer) => {
  const slides: string[] = []
  let isDone = false

  return new Promise<string[]>((resolve, reject) => {
    const processMessage = (msg) => {
      if (isDone) return
      switch (msg.type) {
        case 'slide':
          slides.push(msg.data)
          break
        case 'Done':
          isDone = true
          resolve(slides)
          break
        case 'WARN':
          console.warn('PPTX processing warning: ', msg.data)
          break
        case 'ERROR':
          isDone = true
          console.error('PPTX processing error: ', msg.data)
          reject(new Error(msg.data))
          break
        case 'DEBUG':
          console.debug('Worker: ', msg.data)
          break
        case 'INFO':
        default:
          console.info('Worker: ', msg.data)
      }
    }
    // @ts-expect-error
    processPptx((func) => {
      worker.postMessage = func
    }, processMessage)

    // Start processing of PPTX file
    worker.postMessage({
      type: 'processPPTX',
      data: pptxArrayBuffer
    })
  })
}

export default parsePptxSlides
